import { ApiSchema } from "@api-types";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { hasAnyPolicy$ } from "helpers/hasPolicy";
import React from "react";
import { useSubscription } from "rsm/useSubscription";
import { of } from "rxjs";
import { getFFService } from "services/ff.service";

const PageRoute: React.FC<{
  El: React.LazyExoticComponent<React.FC<{}>>;
  inPolicies?: ApiSchema.Policy[];
  ff?: ApiSchema.FF;
}> = ({ El, inPolicies, ff }) => {
  useSubscription(
    inPolicies?.length ? hasAnyPolicy$(inPolicies) : of(true),
    (hasPolicy) => {
      if (inPolicies?.length && !hasPolicy) {
        window.location.href = "/";
      }
    },
    [inPolicies?.length, inPolicies?.join(",")],
  );
  useSubscription(
    ff ? getFFService().featureEnabled$(ff) : of(true),
    (hasFeature) => {
      if (!hasFeature) {
        window.location.href = "/";
      }
    },
    [ff],
  );
  return (
    <React.Suspense fallback={<LoadingPage />}>
      <El />
    </React.Suspense>
  );
};

export default PageRoute;
